// Replenishment > Produtos em falta — cliente da API interna (sessão).
import axios from 'axios';

const BASE_URL = '/api/replenishment/missing';

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 90000,
  withCredentials: true,
});

// Sessão expirada -> login (mesmo comportamento do resto da app)
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/login') {
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export type MissingAccao = 'repor' | 'proteger_t000' | 'sem_stock_t000' | 'avaliar_d2' | 'sem_classificacao';

export interface MissingRow {
  order_date: string;
  sku: string;
  nome: string | null;
  cat1: string | null;
  cat2: string | null;
  estado: string | null;
  enc_falhadas: number;
  enc_so_este: number; // encomendas que falharam só por este SKU
  pp_hit_rate: number; // pontos de hit rate do dia
  linhas: number;
  qty_falhada: number;
  causas: string;
  lojas_em_falta: string;
  n_lojas: number;
  un_envio: number;
  enc_dia: number;
  stock_t_encomenda: number | null;
  lojas_com_stock_encomenda: number | null;
  cod_dia: string | null;
  snapshot_actual: string | null;
  cod_actual: string | null;
  motivo_v3: string | null;
  ressalva_v3: string | null;
  stock_t_actual: number | null;
  compra_t: number | null;
  transito_t: number | null;
  vel_t: number | null; // un./dia = vendas 30d (online + lojas) / 30
  v30_total: number;
  v30_online: number;
  v30_lojas: number;
  lojas_com_stock_actual: number | null;
  primeira_encomenda: string | null; // DATETIME Lisboa
  snapshot_stock: string | null; // snapshot p_stocks da 1.ª encomenda falhada
  stock_a000: number | null;
  stock_b000: number | null;
  stock_c000: number | null;
  stock_d000: number | null;
  stock_e000: number | null;
  stock_f000: number | null;
  stock_t000_momento: number | null;
  dias_falha_28d: number | null;
  enc_falha_28d: number | null;
  dias_t_actual: number | null; // null = sem vendas online (infinito) ou sem stock
  stock_t_apos: number | null;
  dias_t_apos: number | null;
  accao: MissingAccao;
  accao_pt: string;
}

export interface MissingDay {
  order_date: string;
  enc: number;
  hits: number;
  hit_rate: number | null;
  enc_ausencia: number;
  enc_so_ausencia: number;
  enc_so_este_repor: number;
  hit_rate_se_repor: number | null;
}

export interface MissingList {
  start: string;
  end: string;
  t_min_days: number;
  snapshot_actual: string | null;
  count: number;
  limit: number;
  offset: number;
  results: MissingRow[];
  counts_accao: Record<MissingAccao, number>;
  days: MissingDay[];
}

export interface MissingFilters {
  start?: string;
  end?: string;
  stores?: string;
  causas?: string;
  cod?: string;
  accao?: string;
  search?: string;
  t_min_days?: string;
  ordering?: string;
}

const clean = (filters: object) =>
  Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== undefined && v !== null && v !== ''));

export const exportUrl = (filters: MissingFilters): string => {
  const qs = new URLSearchParams(clean(filters) as Record<string, string>).toString();
  return `${BASE_URL}/export/${qs ? `?${qs}` : ''}`;
};

export const replenishmentMissingApi = {
  list: async (filters: MissingFilters, limit: number, offset: number): Promise<MissingList> =>
    (await client.get('/', { params: clean({ ...filters, limit, offset }) })).data,
};
